<template>
  <div class="zdh-float-div" :style="{width:w,float:d}">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    w: {
      type: String,
      default: 'auto'
    },
    d: {
      type: String,
      default: 'left'
    }
  }
}
</script>
<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/panel/FloatDiv.vue